__turbopack_context__.v({
  "content_nav": "FxNClq_content_nav",
  "content_nav__scrolled": "FxNClq_content_nav__scrolled",
  "content_nav__splide_arrow": "FxNClq_content_nav__splide_arrow",
  "content_nav_item": "FxNClq_content_nav_item",
  "content_nav_link": "FxNClq_content_nav_link",
  "content_nav_link__active": "FxNClq_content_nav_link__active",
  "content_nav_list": "FxNClq_content_nav_list",
  "passport_compass": "FxNClq_passport_compass",
});
